import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from "../../../adapter-vue";
import { TUIGlobal } from "@tencentcloud/chat-uikit-engine";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  show: {
    type: Boolean,
    default: () => false,
  }
},
  emits: ['update:show'],
  setup(__props, { emit }) {

const props = __props

const isWeChat = ref(TUIGlobal.getPlatform() === "wechat");



const showMask = ref(false);

watchEffect(() => {
  showMask.value = props.show;
});



const toggleView = () => {
  showMask.value = !showMask.value;
  emit('update:show', showMask.value);
}


return { __sfc: true,isWeChat, props, showMask, emit, toggleView }
}

})